import _ from 'lodash'
import moment from 'moment'
import { createSelector } from 'reselect'

import { CriterionV2 } from 'constants/service'
import { TIME_TYPE } from 'services/legacy/dailyDiary/constants'

import { changeHours, isPastDay } from 'utils/date'

import { RootState } from 'core/reducers'

const getDailyDiaryMedicationsState = (state: RootState) => state?.dailyDiaryMedications

export const getDailyDiaryMedicationsList = createSelector([getDailyDiaryMedicationsState],
  (state) => state?.list?.data,
)

export const getDailyDiaryActiveMedicationsList = createSelector([getDailyDiaryMedicationsList],
  (state) => _.filter(state, ({ diaryRecords }) => !!diaryRecords?.length),
)

interface GetCriteriaProps {
  entryDate?: string
  room?: string
  timeType?: string
}

export const getDailyDiaryMedicationsListCriteria = ({
  entryDate,
  room,
  timeType,
}: GetCriteriaProps): CriterionV2[] => {
  const criteria: CriterionV2[] = []

  criteria.push({
    comparator: 'after',
    field: 'entryDate',
    value: entryDate,
  })

  criteria.push({
    comparator: 'before',
    field: 'entryDate',
    value: entryDate,
  })

  if (room) {
    criteria.push({
      field: 'child.nurseryClass',
      value: room,
    })
  }

  if (timeType === TIME_TYPE.CURRENTLY_TIMED_IN && !isPastDay(entryDate)) {
    criteria.push({
      comparator: 'after',
      field: 'signIns.signedOutAt',
      value: changeHours(entryDate, moment()).toISOString(),
    })
  }

  criteria.push({
    field: 'present',
    value: true,
  })

  return criteria
}
